import {
  deleteAuthenticated,
  getAuthenticated,
  postAuthenticated,
} from './http';

export const fetchPushConfig = async () => getAuthenticated('/api/push/config');

export const fetchPushStatus = async () => getAuthenticated('/api/push/status');

export const registerPushSubscription = async ({ locale, subscription }) =>
  postAuthenticated('/api/push/subscriptions', { locale, subscription });

export const removePushSubscription = async (endpoint) =>
  deleteAuthenticated('/api/push/subscriptions', {
    data: { endpoint },
  });
